import { createPlanveraAuthClient } from "@planvera/app-commons/auth";
import { invalidateCsrfToken } from "@/utils/orpc";

export const authClient = createPlanveraAuthClient({
	apiUrl: import.meta.env.VITE_API_URL,
	onSessionChange: () => {
		invalidateCsrfToken();
	},
});

export type Session = typeof authClient.$Infer.Session;
export type User = typeof authClient.$Infer.Session.user;
